import type { Faq } from './Contentful';
import type { Image } from './Image';
import type { ProductGroupName } from './ProductGroupKey';

export type ProductGroupConfig = {
    name: ProductGroupName | string;
    designInspirationCategoryKey: string;
    relatedProductsNames?: string[];
};

export interface ProductGroupAttributes {
    type: ProductGroupType;
    subtitle: string;
    hero: Image[];
    designOutcome: string;
    collaborationMethod: CollaborationMethod;
    title: string;
    description: string;
    inclusions: string[];
    faqs?: Faq[];
    active: boolean;
}

export interface ProductGroup extends ProductGroupConfig {
    attributes: ProductGroupAttributes;
}

export enum CollaborationMethod {
    Contest = 'COLLABORATION_METHOD_CONTEST',
    ContestBundle = 'COLLABORATION_METHOD_CONTEST_BUNDLE',
    OneToOneProject = 'COLLABORATION_METHOD_ONE_TO_ONE_PROJECT',
    Studio = 'COLLABORATION_METHOD_STUDIO',
    Care = 'COLLABORATION_METHOD_CARE',
}

export enum ProductGroupType {
    Nil = 'PRODUCT_GROUP_NIL',
    Contest = 'PRODUCT_GROUP_CONTEST',
    FixedPrice = 'PRODUCT_GROUP_FIXED_PRICE',
}
